class ProductCardSwatchScroll {
  constructor() {
    this.init();
  }

  init() {
    this.swatchContainers = document.querySelectorAll('.product-card__swatches');
    if (!this.swatchContainers.length) return;
    
    this.setupScrollButtons();
  }

  setupScrollButtons() {
    this.swatchContainers.forEach(container => {
      const swatchList = container.querySelector('.swatches--product-card');
      const prevButton = container.querySelector('[data-scrollbar-arrow-prev]');
      const nextButton = container.querySelector('[data-scrollbar-arrow-next]');
      
      if (!swatchList || !prevButton || !nextButton) return;

      // Initial check for scroll buttons visibility
      this.updateScrollButtonsVisibility(swatchList, prevButton, nextButton);

      // Listen for scroll events to update button visibility
      swatchList.addEventListener('scroll', () => {
        this.updateScrollButtonsVisibility(swatchList, prevButton, nextButton);
      });

      // Setup click handlers
      prevButton.addEventListener('click', () => {
        const scrollAmount = swatchList.offsetWidth;
        swatchList.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth'
        });
      });

      nextButton.addEventListener('click', () => {
        const scrollAmount = swatchList.offsetWidth;
        swatchList.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
      });
    });
  }

  updateScrollButtonsVisibility(swatchList, prevButton, nextButton) {
    // Check if content is scrollable
    const isScrollable = swatchList.scrollWidth > swatchList.clientWidth;
    
    if (!isScrollable) {
      // If content isn't scrollable, hide both buttons
      prevButton.classList.add('is-hidden');
      nextButton.classList.add('is-hidden');
      return;
    }

    // Check if we can scroll left
    const canScrollLeft = swatchList.scrollLeft > 0;
    prevButton.classList.toggle('is-hidden', !canScrollLeft);

    // Check if we can scroll right
    const canScrollRight = swatchList.scrollLeft < (swatchList.scrollWidth - swatchList.clientWidth - 1); // -1 to account for potential rounding
    nextButton.classList.toggle('is-hidden', !canScrollRight);
  }
}

// Initialize the scroll functionality
customElements.define('product-card-swatch-scroll', class extends HTMLElement {
  connectedCallback() {
    new ProductCardSwatchScroll();
  }
}); 